import React, { useState } from "react";
import { ImageViewer } from "antd-mobile";
import { clampDims, mediaDimCache, IMG_MAX_W, IMG_MAX_H, UploadProgress } from "./utils";

// 未知尺寸时的占位大小，使图片在加载前就占据固定空间，避免高度突变
const PLACEHOLDER = { w: IMG_MAX_W, h: Math.round(IMG_MAX_W * 0.75) };

export default function ImageMessage({ msg }) {
  const url = msg.file?.url || msg.attach?.url || "";
  const previewSrc = msg.previewImg || url;
  if (!previewSrc) return null;

  const isUploading = msg.uploadProgress !== undefined && msg.uploadProgress < 100;
  const progress = msg.uploadProgress ?? 0;

  // 优先级：消息字段 > 持久缓存 > 占位尺寸
  // useState 初始化时即从缓存读取，组件首次渲染已有正确高度（再次进入会话时命中）
  const [dims, setDims] = useState(() =>
    clampDims(msg.file?.w || msg.attach?.w, msg.file?.h || msg.attach?.h, IMG_MAX_W, IMG_MAX_H) ||
    mediaDimCache.get(msg.idClient) ||
    PLACEHOLDER
  );

  return (
    <div
      className="imc-bubble-media"
      style={{ width: dims.w, height: dims.h }}
      onClick={(e) => {
        if (isUploading) return;
        if (e.currentTarget.closest(".imc-msg-pressable")?._longPressed) return;
        if (url) ImageViewer.show({ image: url });
      }}
    >
      <img
        src={previewSrc}
        alt="图片"
        className="imc-msg-image"
        style={{ width: dims.w, height: dims.h, opacity: isUploading ? 0.55 : 1 }}
        onLoad={(e) => {
          if (isUploading) return;
          const { naturalWidth: nw, naturalHeight: nh } = e.currentTarget;
          const d = clampDims(nw, nh, IMG_MAX_W, IMG_MAX_H);
          if (!d) return;
          mediaDimCache.set(msg.idClient, d);
          // 仅当实际尺寸与当前状态不同时才触发重渲染（减少无谓更新）
          if (d.w !== dims.w || d.h !== dims.h) setDims(d);
        }}
      />
      {isUploading && <UploadProgress progress={progress} />}
    </div>
  );
}
